import request from '@/CommonDP/utils/request';
import { getToken } from "../utils";

export default {
  // 中心文件备份目录树
  getRevitBackUpTree(enterpriseId, prjId) {
    return request
      .get(`/revitBackUp/getTree?enterpriseId=${enterpriseId}&prjId=${prjId}`)
      .then((res) => res);
  },
  // 获取自动备份设置
  getRevitBackUpRules() {
    return request
      .get(`/revitBackUp/getBackupRules`)
      .then((res) => res);
  },
  // 保存自动备份规则
  revitBackUpSave(params) {
    return request.post(`/revitBackUp/save`, params).then((res) => res);
  },
  // 获取备份记录列表
  getRevitBackUpRecordList(startTime, endTime) {
    return request
      .get(`/revitBackUp/record/list?startTime=${startTime}&endTime=${endTime}`)
      .then((res) => res);
  },
  // 获取中心文件信息
  getCentralFile(fileId, prjId) {
    return request
      .get(`/revitBackUp/getCentralFile?fileId=${fileId}&prjId=${prjId}`)
      .then((res) => res);
  },
  // 中心文件-准备下载
  getDownloadStatus(fileId, prjId, id, backupFolder) {
    if (getToken()) {
      return request
        .get(`/revitBackUp/download/status?fileId=${fileId}&prjId=${prjId}&id=${id}&backupFolder=${backupFolder}`)
        .then((res) => res);
    }
  }

};
